export enum Flags {
  HideMyChoiceBanner = 'HideMyChoiceBanner',
}

export interface FeatureFlags {
  [Flags.HideMyChoiceBanner]: boolean;
}
